<style lang="scss" scoped>
.slide-10 {
  background-image: url(../../../assets/module2/slide10/background-01.jpg);
  background-size: cover;
  background-position: center;
  height: calc(100% - 100px);
  padding: 50px 0;

  .pages {
    padding-top: 50px;
  }

  .page-left {
    flex-basis: 60%;
  }

  .page-right {
    flex-basis: 40%;
  }

  .heading {
    margin-bottom: 30px;
  }
  .heading1 {
    margin-left: -30px;
  }
  .heading2 {
    margin-left: 30px;
  }
  .heading3 {
    margin-left: 0;
  }
  .heading5 {
    color: #f8dc61;
    font-size: 40px;
  }

  .heading6 {
    font-size: 40px;
  }

  .blue {
    color: #09509c;
  }

  .copy1,
  .copy2,
  .copy3 {
    margin-bottom: 30px;
    width: 550px;
  }
}
</style>

<template>
  <div class="slide-10">
    <transition name="scale" appear>
      <img
        v-show="slideIndex == 9"
        src="@/assets/module2/slide10/photos-01.png"
        class="chars delay-3"
      />
    </transition>

    <div class="pages">
      <div class="page page-left">
        <div class="heading">
          <transition name="fadeUp" appear>
            <h1 class="heading1 delay-1" v-show="slideIndex == 9">
              {{ $t("module2.slide10.heading1") }}
            </h1>
          </transition>
          <transition name="fadeUp" appear>
            <h1 class="heading2 delay-2" v-show="slideIndex == 9">
              {{ $t("module2.slide10.heading2") }}
            </h1>
          </transition>
          <transition name="fadeUp" appear>
            <h1 class="heading3 delay-3" v-show="slideIndex == 9">
              {{ $t("module2.slide10.heading3") }}
              <span class="blue">{{ $t("module2.slide10.heading4") }}</span>
            </h1>
          </transition>
        </div>

        <transition name="fadeUp" appear>
          <p class="copy1 delay-4" v-show="slideIndex == 9">
            {{ $t("module2.slide10.copy1") }}
          </p>
        </transition>
        <transition name="fadeUp" appear>
          <h2 class="heading5 delay-5" v-show="slideIndex == 9">
            {{ $t("module2.slide10.heading5") }}
          </h2>
        </transition>
      </div>

      <div class="page page-right">
        <transition name="fadeRight" appear>
          <p class="copy2 delay-1" v-show="slideIndex == 9">
            {{ $t("module2.slide10.copy2") }}
          </p>
        </transition>
        <transition name="fadeRight" appear>
          <p class="copy3 delay-2" v-show="slideIndex == 9">
            {{ $t("module2.slide10.copy3") }}
          </p>
        </transition>
        <transition name="fadeRight" appear>
          <h2 class="heading6 blue delay-3" v-show="slideIndex == 9">
            {{ $t("module2.slide10.heading6") }}
          </h2>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["slideIndex"]
};
</script>
